module.exports = __webpack_public_path__ + "img/statistic-outline.b9a783fc.svg";